import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SessionDTO } from "../dtos/SessionDTO";
import { Status } from "../lib/globalEnums";
import Spinner from "../components/Spinner";
import { RankDTO } from "../dtos/RankDTO";

export default function Session() {
  const { sessionKey } = useParams();
  const session_key = sessionKey ? parseInt(sessionKey, 10) : -1
  const [session] = useState(new SessionDTO({session_key: session_key}))
  const [status, setStatus] = useState(Status.loading)
  useEffect(() => {
    setStatus(Status.loading)
    session.load(session_key).then(() => {
      setStatus(Status.ready)
    })
  }, [session, session_key])
  if (status === Status.loading) {
    return (
      <div>
        <Spinner />
      </div>
    );
  }
  return (
    <div className="w3-container">
      <h3>Rangliste {session.session_name}</h3>
      <table>
        <tbody>
          {
            session.ranks.map((rank, index) => {
              return (
                <tr key={`rank-${index}`}>
                  <td>{rank.position}</td>
                  <td className="w3-hide-small w3-hide-medium"><img src={rank.headshot_url} alt={rank.full_name} /></td>
                  <td>
                    <div>{rank.full_name}</div>
                    <div className="w3-hide-large"><ColorTeamName rank={rank} /></div>
                  </td>
                  <td className="w3-hide-small w3-hide-medium"><ColorTeamName rank={rank} /></td>
                  <td>{rank.country_code}</td>
                </tr>
              )
            })
          }
        </tbody>
      </table>
    </div>
  );
}

function ColorTeamName(props: {
  rank: RankDTO
}) {
  return <span
    style={{
        color: '#' + props.rank.team_colour,
        fontWeight: 'bold'
      }}
    >{props.rank.team_name}</span>
}
